// extracted by mini-css-extract-plugin
module.exports = {"BigBox":"BigBox__BigBox___Qf57m","Header":"BigBox__Header___2EPGi","Content":"BigBox__Content___1Tl8I"};